import { render, staticRenderFns } from "./ExpandY.vue?vue&type=template&id=3921c58f&scoped=true&"
import script from "./ExpandY.vue?vue&type=script&lang=js&"
export * from "./ExpandY.vue?vue&type=script&lang=js&"
import style0 from "./ExpandY.vue?vue&type=style&index=0&id=3921c58f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3921c58f",
  null
  
)

export default component.exports